import { useState } from "react";
import Draggable from "react-draggable";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { palette, themeWidth } from "../../themes/theme";
import { Box, Typography } from "@mui/material";
import { MapLayoutWidth } from "../../utils/helper";

export const CustomDraggable = ({
  width,
  height,
  isToolbox = false,
  customHeader,
  headerTitle,
  customFooter,
  customComponent,
  left,
  top,
  children,
  disableOverflow,
  bounds,
}) => {
  const [controlledPosition, setControlledPosition] = useState({
    x: left ? left : window.innerWidth - width - 10 - (isToolbox ? 0 : 100),
    y: top ? top : isToolbox ? 200 : 50,
  });

  const handleDrag = (e, position) => {
    const { x, y } = position;
    setControlledPosition({ x, y });
  };

  return (
    <Draggable
      position={controlledPosition}
      handle=".draggable-header"
      bounds={{
        left: bounds?.left || themeWidth[MapLayoutWidth],
        top: bounds?.top || 10,
        right: bounds?.right || window.innerWidth - width - 10,
        bottom: bounds?.bottom || window.innerHeight - 10 - height,
      }}
      onStop={handleDrag}
    >
      {customComponent ? (
        customComponent
      ) : (
        <Box
          sx={{
            width,
            height,
            position: "absolute",
            zIndex: 4,
            borderRadius: 3,
            background: palette.background.light,
            boxShadow: "1px 3px 12px black",
            p: "8px 20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {customHeader ? (
            customHeader
          ) : (
            <div
              style={{
                display: "flex",
                gap: 12,
                padding: "8px 0 8px 0px",
                cursor: "all-scroll",
              }}
              className="draggable-header"
            >
              <DragIndicatorIcon color={palette.text.dark} />
              {headerTitle && (
                <Typography
                  sx={{ color: palette.text.dark, fontWeight: "bold" }}
                >
                  {headerTitle}
                </Typography>
              )}
            </div>
          )}
          <Box
            sx={{
              ...(!disableOverflow
                ? { overflowY: "auto", overflowX: "hidden" }
                : {}),
              height: "70%",
              pr: 1,
            }}
          >
            {children}
          </Box>
          {customFooter && (
            <Box sx={{ display: "flex", justifyContent: "end", gap: 2, py: 1 }}>
              {customFooter}
            </Box>
          )}
        </Box>
      )}
    </Draggable>
  );
};
